const showPendingChecks = () => {
   let vue = window.getApp;
   let params = {
      filterBy: [
         {
            field: 'statusId',
            value: 1,
            label: 'Pendente'
         },
         {
            field: 'dateRangeField',
            value: 'cash_at',
            label: ''
         },
         {
            field: 'dateRange',
            value: [null, vue.$util.dateRange.today.end()],
            label: `Para Depositar até ${vue.$util.dateRange.today.end('MMM/DD/YYYY')}`
         }
      ]
   };

   if (vue.$route.name !== 'Exchanges') {
      vue.$router.push({
         name: 'Exchanges',
         params
      });
   } else {
      vue.$store.dispatch('updateAllPageFilters', params.filterBy);
   }
};


export default [
   {
      name: 'APP_LOGIN_SUCCESS',
      callback: function (e) {
         let home = "Dashboard";
         // home = this.$uCan({ key: 'home' }) || this.$uCan({ key: 'homeExchange' }) || 'Company';
         this.$router.replace({ name: home });
      }
   },
   {
      name: 'APP_LOGOUT',
      callback: async function (e) {
         console.log('APP LOGOUT EVT');
         await this.$api.authService.logoutAffiliate();
         setTimeout(() => {
            document.location.href = '/';
         }, 500);
      }
   },
   {
      name: 'APP_PAGE_LOADED',
      callback: function (e) {
      }
   },
   {
      name: 'APP_AUTH_FAILED',
      callback: function (e) {
         this.$router.replace('/login');
         this.$message.error('Token has expired');
      }
   },
   {
      name: 'APP_BAD_REQUEST',
      callback: function (msg) {
         this.$message.error(msg);
      }
   },
   {
      name: 'APP_ACCESS_DENIED',
      callback: function (msg) {
         this.$message.error(msg);
         this.$router.push('/forbidden');
      }
   },
   {
      name: 'APP_RESOURCE_DELETED',
      callback: function (msg) {
         this.$message.success(msg);
      }
   },
   {
      name: 'APP_RESOURCE_UPDATED',
      callback: function (msg) {
         this.$message.success(msg);
      }
   },
   {
      name: 'HTTP_BEFORE_REQUEST',
      callback: function (msg) {
         // this.$message.success(msg);
      }
   },
   {
      name: 'HTTP_AFTER_RESPONSE',
      callback: function (msg) {
         // this.$message.success(msg);
      }
   },
   {
      name: 'HTTP_RESPONSE_ERROR',
      callback: function (msg) {
         // this.$message.success(msg);
      }
   },

   {
      name: 'APP_USER_NOTIFICATION_CLICK',
      callback: function (notification) {
         switch (+notification.type) {
            case 1:
               showPendingChecks();
               break;
         }

      }
   },


];



// WEBPACK FOOTER //
// ./src/event.js